import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RATE_LIMIT_STATUS = 429;
const EMPTY_FORM = { name: "", phone: "", message: "", service: "", website: "", sms_consent: false };

function errorMessage(err, t) {
  if (err?.response?.status === RATE_LIMIT_STATUS) return t.contact.tooMany;
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  return t.contact.error;
}

export function useLeadForm(t, lang) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const onChange = (e) => {
    const { name, type, checked, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      setStatus({ state: "error", msg: t.contact.validation });
      return;
    }
    setStatus({ state: "loading", msg: "" });
    try {
      await axios.post(`${API}/leads`, { ...form, language: lang });
      setStatus({ state: "success", msg: t.contact.success });
      setForm(EMPTY_FORM);
    } catch (err) {
      setStatus({ state: "error", msg: errorMessage(err, t) });
    }
  };

  return { form, status, onChange, onSubmit };
}
